import { db } from '@/firebaseApp'

export type Video = {
  id: string | null
  youtubeId: string
  description: string
}

export type VideoList = {
  [index: string]: Video
}

class Videos {
  async createVideo(restaurantId: string, video: Video) {
    await db.ref(`restaurants/${restaurantId}/videos`).push(video)
  }

  async updateVideo(restaurantId: string, videoId: string, video: Video) {
    await db.ref(`restaurants/${restaurantId}/videos/${videoId}`).update(video)
  }

  observeVideos(restaurantId: string, f: (videos: Video[]) => void) {
    db.ref(`restaurants/${restaurantId}/videos`)
      .orderByChild('name')
      .on('value', s => {
        if (s.val()) {
          return f(
            Object.keys(s.val())
              .map(videoId => ({ ...s.val()[videoId], id: videoId }))
              .sort((a, b) => a.sortingOrder - b.sortingOrder)
          )
        }
      })
  }

  async deleteVideo(restaurantId: string, videoId: string): Promise<void> {
    await db.ref(`restaurants/${restaurantId}/videos/${videoId}`).remove()
  }
}

export default new Videos()
